import React from 'react';
import { Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FORM_ID } from '../../Expenses.meta';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { useExpensesTotal } from './useExpensesTotal';
import { FREQUENCY_OPTIONS } from './ExpensesTotal.meta';
import { ExpensesDTO } from '../../api/useExpensesQuery';

interface Props {
  clientId: string;
  data: ExpensesDTO;
  workflowProps?: WorkflowComponentProps;
}

export const ExpensesTotal = ({ clientId, data, workflowProps }: Props) => {
  const {
    formBag,
    frequency,
    onSubmit,
    estimateExpenses,
    estimateExpensesMutation,
  } = useExpensesTotal({ clientId, data, workflowProps });

  return (
    <Box
      as="form"
      id={FORM_ID}
      onSubmit={onSubmit}
      display="flex"
      alignItems="flex-end"
      height={65}
      css="gap: 8px; grid-area: header"
      aria-label="Total expenses form"
    >
      <Controller
        control={formBag.control}
        name="amount"
        render={({ field: { onChange, ...field } }) => (
          <InputNumberMask
            allowNegative={false}
            label="Amount"
            leftIcon="far fa-dollar-sign"
            decimalScale={2}
            onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
            selectorProps={{
              defaultValue:
                FREQUENCY_OPTIONS.find(({ value }) => value === frequency) || FREQUENCY_OPTIONS[0],
              options: FREQUENCY_OPTIONS,
              onChange: option =>
                formBag.setValue('frequency', option.value, { shouldDirty: true }),
              ariaLabel: 'Total expenses frequency selector',
            }}
            css="min-width: 300px"
            {...field}
          />
        )}
      />

      {data.CanEstimate && (
        <Button
          variant="secondary"
          leftIcon="fas fa-magic"
          onClick={estimateExpenses}
          isLoading={estimateExpensesMutation.isLoading}
        >
          Estimate from Transactions
        </Button>
      )}
    </Box>
  );
};
